import createSharedState from 'hooks/createSharedState';
import { createGlobalState } from 'react-use';

const [useSharedSessionState] = createSharedState();
export { useSharedSessionState };
export const useGlobalAuthPath = createGlobalState('/signin');
export const useGlobalSessionMismatch = createGlobalState();
